// JS file for LessonItem
$(() => {
  const slider = $('.course-info__media-group').owlCarousel({
    items: 1,
    margin: 30,
    loop: true,
    autoplay:true,
    autoplayTimeout:10000,
    autoplayHoverPause:true,
    responsive: {
      768: {
        items: 2,
        nav : false,
        dots: false,
      },
      992: {
        items: 3,
        nav : false,
        dots: false,
      }
    }
  });

  if( $('.course-info__media-group .owl-item').length < 4){
    $('.course-info__media-group').trigger('stop.owl.autoplay');
  }

  $('.j-slider-left').on('click', function () {
    slider.trigger('prev.owl.carousel')
  });

  $('.j-slider-right').on('click', function () {
    slider.trigger('next.owl.carousel')
  });
})

$('.course-info__intro').find('iframe, object, embed').parent().addClass('rwd-video');
$('.course-info__special').find('iframe, object, embed').parent().addClass('rwd-video');
